export default function ApoelLogo() {
  return (
    <img 
  src="https://upload.wikimedia.org/wikipedia/el/thumb/e/e1/APOEL_FC_logo.svg/1200px-APOEL_FC_logo.svg.png" 
  alt="ΑΠΟΕΛ Logo" 
  style={{ width: '100px', height: 'auto' }} 
/>

  );
}
